<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z"
      fill="#0E0E22"
      fill-opacity="0.8"
    />
    <path
      d="M12 10.9375C12.5868 10.9375 13.0625 11.4132 13.0625 12C13.0625 12.5868 12.5868 13.0625 12 13.0625C11.4132 13.0625 10.9375 12.5868 10.9375 12C10.9375 11.4132 11.4132 10.9375 12 10.9375Z"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="0.125"
    />
    <path
      d="M18 13.125C18.6213 13.125 19.125 12.6213 19.125 12C19.125 11.3787 18.6213 10.875 18 10.875C17.3787 10.875 16.875 11.3787 16.875 12C16.875 12.6213 17.3787 13.125 18 13.125Z"
      fill="#0E0E22"
      fill-opacity="0.8"
    />
    <path
      d="M18 10.9375C18.5868 10.9375 19.0625 11.4132 19.0625 12C19.0625 12.5868 18.5868 13.0625 18 13.0625C17.4132 13.0625 16.9375 12.5868 16.9375 12C16.9375 11.4132 17.4132 10.9375 18 10.9375Z"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="0.125"
    />
    <path
      d="M6 13.125C6.62132 13.125 7.125 12.6213 7.125 12C7.125 11.3787 6.62132 10.875 6 10.875C5.37868 10.875 4.875 11.3787 4.875 12C4.875 12.6213 5.37868 13.125 6 13.125Z"
      fill="#0E0E22"
      fill-opacity="0.8"
    />
    <path
      d="M6 10.9375C6.5868 10.9375 7.0625 11.4132 7.0625 12C7.0625 12.5868 6.5868 13.0625 6 13.0625C5.4132 13.0625 4.9375 12.5868 4.9375 12C4.9375 11.4132 5.4132 10.9375 6 10.9375Z"
      stroke="#0E0E22"
      stroke-opacity="0.8"
      stroke-width="0.125"
    />
  </svg>
</template>
